import { render, staticRenderFns } from "./_confirmationStep.vue?vue&type=template&id=1486fd40"
import script from "./_confirmationStep.vue?vue&type=script&lang=js"
export * from "./_confirmationStep.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports